import React, {Component} from 'react';

import I18 from '../../shared/I18';

export default class AirlineGridItem extends React.Component {

	constructor(props) {
		super(props);
	}

	render() {
		return (
			<div className="jb-image-teaser jb-image-teaser-airline jb-image-teaser-small">
				<div className="jb-image-teaser-top">
					<div className="jb-image-teaser-top-img">
						<img src={this.props.image} alt={"Airline Deals - " + this.props.title} className="jb-image-teaser-top-imgtag" />
					</div>


					<div className="jb-image-teaser-overlay jb-text-white" dangerouslySetInnerHTML={{__html: this.props.deals}} />
				</div>
				<a className="jb-image-teaser-bottom"
				   href={this.props.airline}
				   aria-label={this.props.title + I18.t("airlineListApp.airlinegriditem.rating", ", Bewertung: ") + this.props.rating}>
					<div className="jb-airlinebest">
						<img src={this.props.logo} alt={this.props.title}  className={'svgicon--airlinebest svgicon--' + this.props.iataCode} />
					</div>
				</a>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./AirlineListApp/components/AirlineGridItem.jsx